import { render, staticRenderFns } from "./Tips.vue?vue&type=template&id=03917a18&scoped=true"
import script from "./Tips.vue?vue&type=script&lang=ts"
export * from "./Tips.vue?vue&type=script&lang=ts"
import style0 from "./Tips.vue?vue&type=style&index=0&id=03917a18&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03917a18",
  null
  
)

export default component.exports